<div class="page-container">
  <div class="header-section">
    <div class="title-block">
      <h1>Customer Details</h1>
    </div>

    <div class="header-actions">
      <button class="btn-secondary" (click)="openCancelDialog()">
        <span class="material-icons">arrow_back</span> Back
      </button>
      <button class="btn-primary" (click)="saveCustomer()">
        <span class="material-icons">save</span> Save
      </button>
    </div>
  </div>

  <div class="form-card" *ngIf="customer">
    <div class="form-grid-layout">

      <div class="form-group full-width">
        <label class="form-label">Company Name</label>
        <input pInputText [(ngModel)]="customer.title" placeholder="Enter customer name..." />
      </div>

      <div class="form-group">
        <label class="form-label">Street</label>
        <input pInputText [(ngModel)]="customer.street" placeholder="Street & No." />
      </div>

      <div class="form-group">
        <label class="form-label">Country</label>
        <p-select [filter]="true" [options]="availableCountrys" optionLabel="title" optionValue="countryId"
          [(ngModel)]="selectedCountryId">
        </p-select>
      </div>

      <div class="form-group">
        <label class="form-label">ZIP Code</label>
        <input pInputText [(ngModel)]="customer.zip" placeholder="ZIP" />
      </div>

      <div class="form-group">
        <label class="form-label">City</label>
        <input pInputText [(ngModel)]="customer.city" placeholder="City" />
      </div>

      <div class="form-group full-width mt-4">
        <div class="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 class="card-title">Contact Persons</h3>
          <button class="card-action-btn" (click)="addHandler()">
            <span class="material-icons">person_add</span> Add Contact
          </button>
        </div>
        <div class="grid-container-scroll">
          <p-table [value]="contactPersons" [paginator]="true" [rows]="gridState.take ?? 5" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th style="width: 90px">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-dataItem>
              <tr>
                <td><input pInputText [(ngModel)]="dataItem.firstName" /></td>
                <td><input pInputText [(ngModel)]="dataItem.lastName" /></td>
                <td>
                  <button class="btn-delete" (click)="removeHandler(dataItem)" style="border:none;">
                    <span class="material-icons" style="color: var(--labtech-status-error)">delete_outline</span>
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>



<ng-container *ngIf="cancelDialog">
  <p-dialog [modal]="true" [visible]="true" header="Please Confirm" (onHide)="toggleCancelDialog()" [style]="{ width: '450px' }">
    <p style="margin: 30px; font-weight: 500; text-align: center;">
      Are you sure you want to discard the changes?
    </p>
    <ng-template pTemplate="footer">
      <button class="btn-secondary" (click)="toggleCancelDialog()">No</button>
      <button class="btn-primary" (click)="cancelHandler()">Yes</button>
    </ng-template>
  </p-dialog>
</ng-container>
